export const NEW_ICONS_DIRECTORY: string = 'common';
export const PAYMENT_ICONS_DIRECTORY: string = 'payment';
